import React from 'react';
import Link from 'gatsby-link';
import classnames from 'classnames';
import styles from './styles.module.css';

import BackgroundContainer from '../../../components/background-container';
import GridWrap from '../../../components/grid-wrap';

import RoomImage from '../../../images/room.jpg';
import ArrowIcon from '../../../icons/Arrow';

export default ({ heading }) => (
  <BackgroundContainer src={RoomImage}>
    <GridWrap>
      <div className={styles.container}>
        <div className={styles.back}>
          <Link to="/glass">
            <ArrowIcon color="#fff" size={32} direction="left" />
            <span>View all items</span>
          </Link>
        </div>
        <div className={styles.heading}>
          <h1>{heading}</h1>
        </div>
      </div>
    </GridWrap>
  </BackgroundContainer>
);



// WEBPACK FOOTER //
// ./src/page-components/glass-detail/header/index.js